import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AVGS from "./pages/AVGS";
import FBW from "./pages/FBW";
import Payments from "./pages/Payments";
import Customers from "./pages/Customers";
import Expenses from "./pages/Expenses";
import Mahnwesen from "./pages/Mahnwesen";
import Settings from "./pages/Settings";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/avgs" element={<ProtectedRoute><Layout><AVGS /></Layout></ProtectedRoute>} />
            <Route path="/fbw" element={<ProtectedRoute><Layout><FBW /></Layout></ProtectedRoute>} />
            <Route path="/zahlungen" element={<ProtectedRoute><Layout><Payments /></Layout></ProtectedRoute>} />
            <Route path="/kunden" element={<ProtectedRoute><Layout><Customers /></Layout></ProtectedRoute>} />
            <Route path="/ausgaben" element={<ProtectedRoute><Layout><Expenses /></Layout></ProtectedRoute>} />
            <Route path="/mahnwesen" element={<ProtectedRoute><Layout><Mahnwesen /></Layout></ProtectedRoute>} />
            <Route path="/einstellungen" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
